// Cave84 — Import menu (/import).
// One card per supplier invoice importer (utils/invoiceSuppliers.ts), plus the
// CellarTracker CSV import that still lives under Settings.

import { Link } from 'react-router-dom';
import { SUPPLIERS } from '@/utils/invoiceSuppliers';

const cardCls = 'flex flex-col gap-1 p-4 rounded-lg border border-border-subtle bg-surface-1 transition-colors';

export default function ImportHubPage() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-6 space-y-6">
      <div>
        <h1 className="text-lg font-semibold text-text-primary">Import</h1>
        <p className="text-sm text-text-muted mt-1">
          Upload a supplier invoice PDF. Every line is matched to the cellar, checked against the
          invoice totals, and each bottle records where and when it was bought and what it cost.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {SUPPLIERS.map(s => {
          const body = (
            <>
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-medium text-text-primary">{s.name}</p>
                {s.status === 'ready'
                  ? <span className="text-[11px] text-text-muted">{s.currency}</span>
                  : <span className="text-[11px] px-1.5 py-0.5 rounded border border-border-medium text-text-muted">Coming soon</span>}
              </div>
              <p className="text-xs text-text-tertiary">{s.kind}</p>
              <p className="text-xs text-text-muted mt-1 leading-relaxed">{s.description}</p>
            </>
          );
          return s.status === 'ready' ? (
            <Link key={s.id} to={`/import/${s.id}`} className={`${cardCls} hover:border-gold/40 hover:bg-surface-2`}>
              {body}
            </Link>
          ) : (
            <div key={s.id} className={`${cardCls} opacity-60`} aria-disabled="true">{body}</div>
          );
        })}
      </div>

      <p className="text-xs text-text-muted">
        Bulk import from a CellarTracker CSV export is in{' '}
        <Link to="/settings/import" className="text-gold hover:underline">Settings → Import from CellarTracker</Link>.
      </p>
    </section>
  );
}
